"use client";

import { useTelegramContext } from "@/contexts/TelegramContext";
import { getTmaStartParams } from "@/utils/telegram";

/**
 * It tracks the partner of the user based on the partner parameter
 * For web: gets partner from URL parameters
 * For TMA: gets partner from Telegram startParam
 */
export const useUserPartners = () => {
  const { isTMA } = useTelegramContext();

  const getPartnerFromUrl = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const partner = searchParams.get("partner");
    return partner;
  };

  const getPartnerFromTelegram = () => {
    if (!isTMA) {
      return null;
    }

    try {
      const decodedStartParams = getTmaStartParams();

      if (!decodedStartParams) {
        return null;
      }

      return decodedStartParams?.partner || null;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Failed to retrieve partner from TMA launch params:", error);
      return null;
    }
  };

  const getCurrentPartner = () => {
    return isTMA ? getPartnerFromTelegram() : getPartnerFromUrl();
  };

  return {
    getCurrentPartner,
  };
};
